import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoLight from "../../assets/images/final-logo-light.png";
import about from "../../assets/images/about.jpg";
import { TbMailStar, AiFillLinkedin, BiLogoFacebook, AiOutlineInstagram, AiOutlineYoutube } from "../../assets/icons/vander";
import { AiFillBluesky } from "../../assets/icons/BlueskyIcons";
import { AiOutlineClose } from "react-icons/ai"; // Added the close icon
import Modal from "react-bootstrap/Modal";

// Import Firestore functions and your Firebase app configuration
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import app from "../../firebase/firebase";

export default function FooterThree({ top }) {
  // Modal visibility state
  const [show, setShow] = useState(false);
  
  // Firestore instance
  const db = getFirestore(app);

  // Contact form state variables
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [comments, setComments] = useState("");
  const [contactSubmitted, setContactSubmitted] = useState(false);

  // Reset form state
  const resetForm = () => {
    setContactName("");
    setContactEmail("");
    setSubject("");
    setComments("");
    setContactSubmitted(false);
  };

  // Modified handleClose to reset the form
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  // Handle contact form submission
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contact-us-form"), {
        name: contactName,
        email: contactEmail,
        subject: subject,
        comments: comments,
        'contact-opt-in': true,
        timestamp: serverTimestamp(),
      });
      setContactSubmitted(true);
      // Optionally clear the form fields immediately after submission
      // resetForm();
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <>
      <footer className="footer bg-footer">
        {top === false ? (
          ""
        ) : (
          <div className="py-5 footer-border-bottom">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <div className="section-title">
                    <div className="d-flex align-items-center">
                      <TbMailStar className="display-4 text-white title-dark" />
                      <div className="flex-1 ms-md-4 ms-3">
                        <h4 className="fw-semibold text-light title-dark mb-1">
                          Ready to protect your loved ones?
                        </h4>
                        <p className="text-white-50 mb-0">
                          Let us find the right insurance policies to meet your needs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mt-4 mt-sm-0 contactUsButton">
                  <div className="text-md-end ms-5 ms-sm-0">
                    <Link to="#" className="btn btn-primary btn-quote-custom" onClick={handleShow}>
                      Contact Us Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="footer-py-30 footer-bar bg-footer">
          <div className="container">
            <div className="row align-items-center mb-3">
              <div className="col-md-6 bottomFooterLogo">
                <div className="text-center text-md-start">
                  <Link to="/">
                    <img src={logoLight} height="60" alt="" />
                  </Link>
                </div>
              </div>

              <div className="col-md-6 mt-4 mt-md-0">
                <ul className="list-unstyled social-icon foot-social-icon text-center text-md-end mb-0">
                  <li className="list-inline-item">
                    <a
                      href="https://facebook.com/profile.php?id=61573685685409#"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded"
                    >
                      <BiLogoFacebook />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.instagram.com/dscottsmith_ifi/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded"
                    >
                      <AiOutlineInstagram />
                    </a>
                  </li>
                  {/*<li className="list-inline-item">
                    <a
                      href="https://youtube.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded"
                    >
                      <AiOutlineYoutube />
                    </a>
                  </li>*/}
                  <li className="list-inline-item">
                    <a
                      href="https://www.linkedin.com/company/inclusive-family-insurance-group"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded"
                    >
                      <AiFillLinkedin />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://bsky.app/profile/inclusive-fam-ins.bsky.social"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded"
                    >
                      <AiFillBluesky />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="row">
              <div className="col-12">
                <div className="text-center pt-3 border-top border-secondary">
                  <p className="mb-0 text-muted bottomFooterCopyright">
                    {new Date().getFullYear()} © Inclusive Family Insurance LLC. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>



      </footer>

      <Modal
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={handleClose}
        onExited={resetForm}
        centered
      >
        <Modal.Body className="p-0 position-relative overflow-hidden">
          {/* Close button */}
          <button
            onClick={handleClose}
            className="custom-close-button"
            aria-label="Close"
          >
            <AiOutlineClose />
          </button>

          <div className="container-fluid px-0">
            <div className="row align-items-center g-0">
              <div className="col-lg-6 col-md-5 contact-us-padding">
                <h5
                  className="text-primary contact-us-header"
                  style={{ textAlign: "center", marginBottom: "1rem" }}
                >
                  Contact Us
                </h5>
                <img
                  src={about}
                  className="img-fluid rounded-start contact-us-img"
                  alt=""
                />
              </div>

              <div className="col-lg-6 col-md-7">
                {contactSubmitted ? (
                  <div className="p-4">
                    <p className="text-success">
                      Thank you! Your message has been sent successfully.
                    </p>
                  </div>
                ) : (
                  <form className="p-4" onSubmit={handleContactSubmit}>
                    <div id="simple-msg"></div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Your Name <span className="text-danger">*</span>
                          </label>
                          <input
                            name="name"
                            id="name"
                            type="text"
                            className="form-control"
                            placeholder="Name :"
                            required
                            value={contactName}
                            onChange={(e) => setContactName(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Your Email <span className="text-danger">*</span>
                          </label>
                          <input
                            name="email"
                            id="email"
                            type="email"
                            className="form-control"
                            placeholder="Email :"
                            required
                            value={contactEmail}
                            onChange={(e) => setContactEmail(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">Subject</label>
                          <input
                            name="subject"
                            id="subject"
                            className="form-control"
                            placeholder="Subject :"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Comments <span className="text-danger">*</span>
                          </label>
                          <textarea
                            name="comments"
                            id="comments"
                            rows="4"
                            className="form-control"
                            placeholder="Message :"
                            required
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <button
                          type="submit"
                          id="submit"
                          name="send"
                          className="btn btn-primary btn-quote-custom"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
              <div style={{paddingLeft:"30px", paddingRight:"30px"}}>
                <p className="text-muted small mt-0">By submitting this form, you agree to be contacted by David Scott Smith, an independent insurance broker (licensed in VA, NC, SC, TN, and GA) and affiliate of Symmetry Financial Group. You may be contacted by phone, text message, or email at the number and/or email address you provide, even if your number is on a state or federal Do Not Call list. Message and data rates may apply. You may opt out at any time.</p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
